var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import View from "@core/views";
import Ajax from "@core/ajax";
import Toast from "@core/components/Toast";
import { TableEvent } from "@core/plugin/tc/component/table/enums";
var DimensioningJobItemSelection = /** @class */ (function (_super) {
    __extends(DimensioningJobItemSelection, _super);
    function DimensioningJobItemSelection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.TABLE_QUERY_KEY_NAME = 'dimensioningtemporaryrow_selected';
        _this.onSelectAllClick = function (event) {
            var origSearch = location.search;
            var selectAll = 'select_all=true';
            var url = location.href;
            if (origSearch) {
                url = location.href.replace(origSearch, "".concat(origSearch, "&").concat(selectAll));
            }
            else {
                url = "".concat(location.href, "?").concat(selectAll);
            }
            Ajax.json(url, {}, 'get').then(function (result) {
                var pks = result;
                window.dispatchEvent(new CustomEvent(TableEvent.SetSelected, {
                    detail: {
                        id: 'dimensioningtemporaryrow',
                        selected: pks
                    }
                }));
            }, function (error) {
                console.log("Error occurred: ".concat(error.message));
                Toast.error(django.gettext('Error occurred selecting all items!'));
            });
        };
        _this.onDeselectAllClick = function (event) {
            window.dispatchEvent(new CustomEvent(TableEvent.SetSelected, {
                detail: {
                    id: 'dimensioningtemporaryrow',
                    selected: []
                }
            }));
        };
        _this.onItemSelectFormSubmit = function (event) {
            _this.disableToolbarButtons();
        };
        _this.disableToolbarButtons = function () {
            var proceedButton = document.querySelector('#proceed-button');
            proceedButton.classList.add('is-loading');
            proceedButton.disabled = true;
            if (_this.selectAllButton) {
                _this.selectAllButton.disabled = true;
            }
            if (_this.deselectAllButton) {
                _this.deselectAllButton.disabled = true;
            }
        };
        return _this;
    }
    DimensioningJobItemSelection.prototype.onMounted = function () {
        this.selectAllButton = document.querySelector('#select-all-button');
        if (this.selectAllButton)
            this.selectAllButton.addEventListener('click', this.onSelectAllClick);
        this.deselectAllButton = document.querySelector('#deselect-all-button');
        if (this.deselectAllButton)
            this.deselectAllButton.addEventListener('click', this.onDeselectAllClick);
        document.querySelector('#item-selection-form').addEventListener('submit', this.onItemSelectFormSubmit);
    };
    return DimensioningJobItemSelection;
}(View));
export default DimensioningJobItemSelection;
